import {
  Avatar,
  Box,
  Card,
  CardContent,
  colors,
  Grid,
  makeStyles,
  Typography,
} from '@material-ui/core';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { MapPin as MapPinIcon } from 'react-feather';
import { useTranslation } from 'react-i18next';
import CenterSelector from 'src/components/Centers/CenterSelector';

const useStyles = makeStyles({
  root: {
    height: '100%',
  },
  avatar: {
    backgroundColor: colors.red[600],
    height: 56,
    width: 56,
  },
});

const CenterPicker = ({ className, ...rest }) => {
  const classes = useStyles();
  const { t } = useTranslation('centers');

  return (
    <Card className={clsx(classes.root, className)} {...rest}>
      <CardContent>
        <Grid container justify="space-between" spacing={3}>
          <Grid item>
            <Typography color="textSecondary" gutterBottom variant="h6">
              {t('labels.center_title').toUpperCase()}
            </Typography>
          </Grid>
          <Grid item>
            <Avatar className={classes.avatar}>
              <MapPinIcon />
            </Avatar>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <CenterSelector />
        </Grid>
        <Box mt={2} display="flex" alignItems="center">
          <Typography color="textSecondary" variant="body1">
            {t('texts.center_selector')}
          </Typography>
        </Box>
      </CardContent>
    </Card>
  );
};

CenterPicker.propTypes = {
  className: PropTypes.string,
};

export default CenterPicker;
